import SearchFypEntry from "../SearchFypEntry";
import { SearchFypPlacementId } from "@/monarch/rules/searchFypEntry/types";
import type { InlineFypConfig } from "./types";

interface InlineFypBlockProps {
  config: InlineFypConfig;
  inlinePosition: number | null;
  currentIndex: number;
}

export default function InlineFypBlock({
  config,
  inlinePosition,
  currentIndex,
}: InlineFypBlockProps) {
  if (inlinePosition === null || currentIndex !== inlinePosition) {
    return null;
  }

  return (
    <div className="col-span-full">
      <SearchFypEntry
        placement={SearchFypPlacementId.InlineResults}
        forcedFlowId={config.forcedFlowId}
        jumpToStepId={config.jumpToStepId}
        styleVariant={config.styleVariant}
        isLoading={config.isLoading}
      />
    </div>
  );
}
